module.exports = __webpack_public_path__ + "static/media/CICLO_4_GENERO_DIGITAL.0ca766f7.jpg";